import type {
  GetItineraryResponse,
  TripChatRecentSearch,
  TripItineraryData,
} from 'tripPlanner/api/types'
import { normalizeRecentSearches } from './tripChatRecentSearchPayload'

/**
 * Map a contract itinerary result into the FE TripItineraryData shape.
 * Recent-search payloads are normalised from wire format (location.query / API
 * flexible dates) into the drawer-facing locationQuery shape.
 */
export function toTripItineraryData(
  result: GetItineraryResponse['result'],
): TripItineraryData {
  return {
    ...result,
    recentSearches: normalizeRecentSearches(
      result.recentSearches as unknown as Array<TripChatRecentSearch> | undefined,
    ),
  }
}
